import React, { memo } from 'react';
import CardCount from '../../../../../components/CardCount';
import { EPillar } from 'src/backoffice/types/challenges';

interface CardItem {
  title: string;
  value: number;
  pillar: EPillar;
}

interface CustomHeaderProps {
  dataCards: CardItem[];
  onCardClick?: (pillar: EPillar) => void;
  selectedCategory?: EPillar | null;
}

const CustomHeader: React.FC<CustomHeaderProps> = ({ dataCards, onCardClick, selectedCategory }) => (
  <div className="display-flex flex-row align-items-stretch width-100pct rounded-large gap-16 padding-left-10">
    {dataCards.map((card) => {
      const isSelected = selectedCategory === card.pillar;
      return (
        <div
          key={card.title}
          className="width-100pct flex-1 min-width-200 max-width-300 margin-right-20"
        >
          <CardCount
            borderColor="#22bcd4"
            label={card.title}
            value={card.value}
            onClick={() => onCardClick && onCardClick(card.pillar)}
            isActive={isSelected}
          />
        </div>
      );
    })}
  </div>
);

export default memo(CustomHeader);